import React from 'react';

const formatNumber = (number) => {
  return number.toLocaleString('es-CO', { style: 'currency', currency: 'COP' });
};

const ProgressBarComp = ({ raised, goal, donors }) => {
  return (
    <div className='progress-bar-container'>
      <h3 className='title'>¿Cómo va nuestra meta?</h3>
      <div className='ProgressBar'>
        <div
          className='progress'
          style={{ width: `${(raised / goal) * 100}%` }}>
          <span
            className='label'
            style={{
              left: `${
                (raised / goal) * 100 <= 60
                  ? (raised / goal) * 100
                  : (raised / goal) * 100
              }%`,
            }}>
            {formatNumber(raised)} / {formatNumber(goal)}
          </span>
        </div>
      </div>
      <h5 className='donors title'>
        {donors} {donors === 1 ? 'Donación' : 'Donaciones'} realizadas
      </h5>
    </div>
  );
};

export default ProgressBarComp;
